module.exports = __webpack_public_path__ + "img/t2-c12-1.41c80dbd.png";